import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'

interface OriginalMessageRequest {
  id: string
  type: string
}

interface OriginalMessageResponse {
  code: number
  data: {
    fromUsername: string
    msgTime: string
    content: string
    imageUrl: string
  }
}

class GetOriginalMessage extends Http {
  public async getOriginalDataById(data: OriginalMessageRequest) {
    return await super.request<OriginalMessageResponse>({
      url: '/crossbowSystem/getOriginalDataById',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default GetOriginalMessage
